export const UPDATE_GMAPS_STATE = 'UPDATE_GMAPS_STATE'
export const TOGGLE_HEADER = 'TOGGLE_HEADER'
export const TOGGLE_LOGIN = 'TOGGLE_LOGIN'
